import { deleteField, getDoc, writeBatch } from 'firebase/firestore';
import _ from 'lodash';
import { _appVersion } from '../../cnr/contexts/ServiceWorkerContext';
import { dispatchProps, grts } from '../../cnr/reducers/reducerHelpers/dispatchProps';
import { _deleteItemProps, _deleteViProps, dataFix } from '../../common/dataFix';
import { getNow } from '../../common/dateFormatting';
import { _settingsFs } from '../../viewSettings/actions/getSettings';
import { createRefPath, createRefPath_event } from '../appData/appRefPaths';
import { _cacheNames } from '../../cnr/reducers/ServiceWorkerReducer';
import { currentHelpers } from '../../redirection/current';
import { _cacheGroupTypes } from 'global/cnr/contexts/useHelpers/useTimestamp';
import { convertSnapshot } from 'global/cnr/contexts/contextHelpers';
import { getAuth } from 'firebase/auth';
import { logBatch } from 'global/cnr/reducers/reducerHelpers/logging';

export const _allowUpdates_settings = true

const _allowUpdates_fromSidebar = true
const _settingsGlobalDocument = 'global'

export const _settingsUpdateModes = {
  full: 'full',
  global: 'global',
  views: 'views',
  viewItems: 'viewItems',
  viewsAndViewItems: 'viewsAndViewItems',
  globalAndViewItems: 'globalAndViewItems',
}

// const separateSaveViewItems = false
// https://howtofirebase.com/firebase-security-rules-88d94606ce4a

export const updateSettings = (database_fns, mainDb) => ({
  getBackupSettings: (pathViews) => getBackupSettings(database_fns, mainDb, pathViews),
  cleanUpSettings: (viewKey, views, viewItems) => cleanUpSettings(viewKey, views, viewItems),
  createNewViewAndViewItemsSettingsDB: (settingsProps, pathViews, callback) => createNewViewAndViewItemsSettingsDB(database_fns, settingsProps, pathViews, callback),
  createNewViewsAndViewItemsSettingsToDb: (pathViews, projectSettings, globalOnly, callback) => createNewViewsAndViewItemsSettingsToDb(database_fns, pathViews, projectSettings, globalOnly, callback),
  updateFromSidebar: (settingsDocName, view, data, appUser, callback) => settingsUpdate_fromSidebar(database_fns, mainDb, settingsDocName, view, data, appUser, callback),
  updateGlobalFromSidebar: (pathViews, data, appUser, callback) => settingsUpdate_globalFromSidebar(database_fns, mainDb, pathViews, data, appUser, callback),
  updateGlobalAndViewsDBSettings: (fullDbSettings, paps_state, sandboxOn, appUser, callback) => updateGlobalAndViewsDBSettings(fullDbSettings, paps_state, sandboxOn, appUser, callback),
  updateHomeGlobalSettingsToDb: (dataToUpdate, callback, appUser) => updateHomeGlobalSettingsToDb(database_fns, mainDb, dataToUpdate, callback, appUser),
  updateNewViewToViewsSettingsDB: (viewKey, views, pathViews, callback, forBackup) => updateNewViewToViewsSettingsDB(database_fns, viewKey, views, pathViews, callback, forBackup),
  updateSettings_viewItemsOnly: (pathViews, settings) => updateSettings_viewItemsOnly(database_fns, pathViews, settings),
  updateSettingsDocsToDatabase: (allAppSettings, response) => updateSettingsDocsToDatabase(database_fns, allAppSettings, response),
  updateSettingsToDB: (data, dispatch) => updateSettingsToDB(database_fns, mainDb, data, dispatch),
  updateSettingsToDB_direct: (settingsUpdateMode, data, settingsDocName, merge, forBackup, appUser, callback, altDb) => updateSettingsToDB_direct(settingsUpdateMode, database_fns, mainDb, data, settingsDocName, merge, forBackup, appUser, callback, altDb),
  updateViewItemsToDb: (pathViews, viewItems, ammendedKeys) => updateViewItemsToDb(database_fns, pathViews, viewItems, ammendedKeys),
  updateViewViewItemSettingsDB: (pathViews, viewItem, viewKey, callback) => updateViewViewItemSettingsDB(database_fns, pathViews, viewItem, viewKey, callback),
  updateViewViewItems: (pathViews, viewItem, viewKey, appUser, callback) => updateSettings_viewViewItems(database_fns, mainDb, pathViews, viewItem, viewKey, appUser, callback),
  updateSettings_updatesOnly: (datasToUpdate, settingsDocName, appUser, callback) => updateSettings_updatesOnly(database_fns, mainDb, datasToUpdate, settingsDocName, appUser, callback),
})

export const dv = (value) => {
  const allDocs = {}
  value.forEach(doc => { m(allDocs, doc) })
  return allDocs
}

const getBackupSettings = async (database_fns, mainDb, pathViews) => {

  const settings_name = _settingsFs.rootBackup
  const docName = pathViews.events || pathViews.clients
  const baseRef = createRefPath([settings_name, docName])

  // create the ref paths
  const paths = {
    base: baseRef,
    global: createRefPath([_settingsFs.collection, _settingsGlobalDocument], baseRef),
    viewItems: createRefPath([_settingsFs.collection, 'viewItems'], baseRef),
    views: createRefPath([_settingsFs.collection, 'views'], baseRef),
  };

  const _settings = _.fromPairs(
    await Promise.all(
      _.map(paths, async (refPath, key) => {
        const docRef = await database_fns.get_doc({
          refPath,
          forPromise: true,
        });

        const snap = await getDoc(docRef);

        return [
          key,
          convertSnapshot(snap, true, { returnFirstObject: true, ignoreId: true })
        ];
      })
    )
  );

  return _settings
}

const cleanUpSettings = (viewKey, views, viewItems) => {

  const removes = []

  const _viewItems = _.cloneDeep(views)
  const _views = _.cloneDeep(viewItems)

  delete _viewItems[viewKey]
  removes.push({ 'viewItem': viewKey })

  // clean up views > viewItems
  Object.keys(_views).forEach(viewKey => {
    const view = _views[viewKey]
    if (view && view.viewItems) {
      delete view.viewItems[viewKey]
      removes.push({ 'views': viewKey })
    }
  })

  Object.keys(_viewItems).forEach(viKey => {
    const viewItem = _viewItems[viKey]
    if (viewItem && viewItem.props) {
      delete viewItem.props[viewKey]
      removes.push({ 'props': viewKey })
    }
  })

  delete _views[viewKey]

  return { views: _views, viewItems: _viewItems }
}

const updateSettings_updatesOnly = async (
  database_fns,
  mainDb,
  datasToUpdate,
  settingsDocName,
  appUser,
  callback,
) => {
  const { displayName, uid } = appUser ?? {}
  const settings_name = _settingsFs.root
  const baseRef = createRefPath([settings_name, settingsDocName])
  const _timestamp = getNow()

  const status = {
    uid,
    displayName,
    appVersion: _appVersion,
    lastUpdate: _timestamp
  }

  const allows = {
    global: !_.isEmpty(datasToUpdate?.global),
    viewItems: !_.isEmpty(datasToUpdate?.viewItems),
    views: !_.isEmpty(datasToUpdate?.views)
  }

  const paths = {
    base: baseRef,
    global: allows.global && createRefPath([_settingsFs.collection, _settingsGlobalDocument], baseRef),
    viewItems: allows.viewItems && createRefPath([_settingsFs.collection, 'viewItems'], baseRef),
    views: allows.views && createRefPath([_settingsFs.collection, 'views'], baseRef)
  };

  const batch = writeBatch(mainDb);

  database_fns.set_doc(baseRef, status, true, false, batch);

  // (refPath, data, callback, batch, appUserAccess, storagePaths, vit) => fs_update_doc(mainDb, refPath, data, callback, batch, appUserAccess, storagePaths, vit)
  if (allows.global && paths.global) {
    database_fns.update_doc(paths.global, datasToUpdate.global, null, batch);
  }
  if (allows.viewItems && paths.viewItems) {
    database_fns.update_doc(paths.viewItems, datasToUpdate.viewItems, null, batch);
  }
  if (allows.views && paths.views) {
    database_fns.update_doc(paths.views, datasToUpdate.views, null, batch);
  }

  // /settings/DB5dG6CGnhp0PqbxP19l/settings/global
  // /settings/DB5dG6CGnhp0PqbxP19l/settings/global
  // /settings_backup/DB5dG6CGnhp0PqbxP19l/settings/views
  console.group('updateSettings_updatesOnly', baseRef)
  console.log('datasToUpdate', datasToUpdate)
  console.log('paths', paths)
  console.log('status', status)
  console.groupEnd()

  _.forEach(batch?._mutations, (m) => {
    if (m?.key?.path?.segments) {
      console.log('segments', m?.key?.path?.segments)
    }
  })

  console.groupEnd()

  if (_allowUpdates_settings) {
    database_fns.update_timestamp(_cacheGroupTypes.settings, settingsDocName, _timestamp, batch)
    batch.commit();
  }

  if (callback) {
    console.log('callback')
    callback();
  }

}

const updateSettingsToDB_direct = async (
  settingsUpdateMode,
  database_fns,
  mainDb,
  dataUpdate,
  settingsDocName,
  merge,
  forBackup,
  appUser,
  callback,
  altDb,
) => {

  const { displayName, uid } = appUser ?? {}
  const settings_name = forBackup ? _settingsFs.rootBackup : _settingsFs.root
  const baseRef = createRefPath([settings_name, settingsDocName])
  const _timestamp = getNow()

  const status = {
    uid,
    displayName,
    appVersion: _appVersion,
    lastUpdate: _timestamp
  }

  let _allowGlobal;
  let _allowViews;
  let _allowViewItems

  switch (settingsUpdateMode) {
    case _settingsUpdateModes.full:
      _allowGlobal = true
      _allowViews = true
      _allowViewItems = true
      break;
    case _settingsUpdateModes.global:
      _allowGlobal = true
      break;
    case _settingsUpdateModes.globalAndViewItems:
      _allowGlobal = true
      _allowViewItems = true
      break;
    case _settingsUpdateModes.viewItems:
      _allowViewItems = true
      break;
    case _settingsUpdateModes.views:
      _allowViews = true
      break;
    case _settingsUpdateModes.viewsAndViewItems:
      _allowViewItems = true
      _allowViews = true
      break;
    default:
      _allowGlobal = true
      _allowViews = true
      _allowViewItems = true
  }

  const paths = {
    base: baseRef,
    global: _allowGlobal && createRefPath([_settingsFs.collection, _settingsGlobalDocument], baseRef),
    viewItems: _allowViewItems && createRefPath([_settingsFs.collection, 'viewItems'], baseRef),
    views: _allowViews && createRefPath([_settingsFs.collection, 'views'], baseRef)
  };

  const { global = {}, viewItems = {}, views = {} } = dataUpdate;

  const _mainDb = altDb || mainDb

  const batch = writeBatch(_mainDb);

  database_fns.set_doc(baseRef, status, merge, false, batch, altDb);

  if (_allowGlobal) {
    database_fns.set_doc(paths.global, global, merge, false, batch, altDb);
  }
  if (_allowViewItems) {
    database_fns.set_doc(paths.viewItems, viewItems, merge, false, batch, altDb);
  }
  if (_allowViews) {
    database_fns.set_doc(paths.views, views, merge, false, batch, altDb);
  }

  console.group('updateSettingsToDB_direct', baseRef)
  console.log('db', _mainDb?._databaseId?.projectId)
  console.log('merge', merge)
  console.log('status', status)
  console.log('data', dataUpdate)
  console.groupEnd()

  logBatch(batch, dataUpdate)

  if (_allowUpdates_settings) {
    database_fns.update_timestamp(_cacheGroupTypes.settings, settingsDocName, _timestamp, batch, altDb)
    return batch.commit();
  }

  if (callback) {
    callback();
  }


}

/**
 * This updates (usings Set) the settings to the database
 * @param {object} data (settings_temp, papsProps, isGlobal, sandboxOn, appUser, specificView, appSettingsChanges)
 * @param {function} dispatch 
 * called from fbSettingsFunctions
 */
const updateSettingsToDB = async (database_fns, mainDb, data, dispatch) => {

  const _replaceFull = true

  const { settings_temp, papsProps, isGlobal, sandboxOn, appUser, specificView, appSettingsChanges } = data ?? {}
  const { gvvi, page } = settings_temp ?? {}
  const { displayName, uid } = appUser ?? {}

  let _global;
  let _viewItems;
  let _views;

  if (isGlobal) {
    _global = gvvi.global
    _viewItems = gvvi.viewItems
    _views = gvvi.views
  } else {
    _global = page
    _viewItems = page.viewItems
  }

  const settings_name = _settingsFs.root

  const { pathViews, rootPaths, view, viewKey, landingView, settingsDocName } = papsProps ?? {}

  const newGlobal = _global ? _.cloneDeep(_global) : null
  const newViewItems = _viewItems ? _.cloneDeep(_viewItems) : null
  const newViews = _views ? _.cloneDeep(_views) : null

  const { googleSheets, parentDefaults } = newGlobal ?? {}

  if (googleSheets) {
    let dbPath = rootPaths ? rootPaths.events : null
    dbPath = dbPath ? dbPath.substring(1) : null
    googleSheets.dbPath = dbPath ? dbPath : 'unknown'
  }

  if (parentDefaults) {
    // remove these items from the save
    const { useClientThemes, useHomeTransitions, useClientUiElements, useClientUiSections } = parentDefaults
    if (useClientThemes) {
      delete newGlobal.themedItems
      delete newGlobal.themeColors
    }
    if (useHomeTransitions) { delete newGlobal.transitionItems }
    if (useClientUiElements) { delete newGlobal.uiElements }
    if (useClientUiSections) { delete newGlobal.uiSections }
  }

  let trueViewKey = viewKey ? view : view + '_list'
  trueViewKey = currentHelpers.getTrueView(pathViews, view, trueViewKey, landingView, viewKey)

  if (specificView) { trueViewKey = specificView }

  // ************ 
  const _refPath = []
  let _ref_path;

  if (sandboxOn && appUser && appUser.uid) {
    _refPath.push(settings_name + '_sandbox', settingsDocName)
  } else {
    _refPath.push(settings_name, settingsDocName)
    _ref_path = createRefPath([_settingsFs.root, settingsDocName])
  }

  let dataUpdate;
  let _settingsUpdateMode = _settingsUpdateModes.full

  if (isGlobal) {
    _settingsUpdateMode = _settingsUpdateModes.globalAndViewItems
    if (newViews) {
      dataUpdate = {
        global: newGlobal,
        viewItems: newViewItems,
      }
    } else {
      dataUpdate = {
        global: newGlobal,
        viewItems: newViewItems
      }
    }
  } else {
    // the views. will only update the `views` part of the document 
    dataUpdate = {
      views: { [trueViewKey]: { ..._global, viewItems: newViewItems } },
    }
    _settingsUpdateMode = _settingsUpdateModes.views
  }

  dataUpdate = dataFix.removeNulls(dataUpdate)

  if (dataUpdate.views) {
    Object.keys(dataUpdate.views).forEach(key => {
      const view = dataUpdate.views[key]
      const { viewItems } = view ?? {}
      ammendDeleteFields(viewItems, _replaceFull)
    })
  }

  ammendDeleteFields(dataUpdate.viewItems, _replaceFull)

  // const _timestamp = getNow()

  // dataUpdate.status = {
  //   uid,
  //   displayName,
  //   appVersion: _appVersion,
  //   lastUpdate: _timestamp,
  //   _timestamp: Date.now()
  // }

  const cb = (res) => {
    dispatch && dispatch({ type: dispatchProps.success, dispatch, res })
  }

  const res = await updateSettingsToDB_direct(_settingsUpdateMode, database_fns, mainDb, dataUpdate, settingsDocName, false, false, appUser, cb)
  dispatch && dispatch({ type: dispatchProps.success, dispatch, res })

}

/**
 * 
 * @param {object} pathViews 
 * @param {object} viewItems 
 * @param {array} ammendedKeys 
 */
const updateViewItemsToDb = async (database_fns, pathViews, viewItems, ammendedKeys) => {
  const settings_name = _settingsFs.root
  const baseRef = createRefPath([settings_name, pathViews.events])
  const _refPath = createRefPath([_settingsFs.collection, 'viewItems'], baseRef)
  database_fns.set_doc(_refPath, viewItems, true)
}

/**
 * Updates the settings (fuil). This is using `doc_set`. This will replace the existing settings for `view` and `viewItems`
 * @param {object} pathViews 
 * @param {object} viewItems 
 * @param {object} views 
 * @param {function} callback 
 */
const createNewViewsAndViewItemsSettingsToDb = async (database_fns, pathViews, projectSettings, globalOnly, callback) => {
  createNewViewsAndViewItemsSettings(database_fns, pathViews, projectSettings, globalOnly).then(res => {
    callback && callback({ type: dispatchProps.success, callback, res })
  })
}

/**
 * Updates the settings/home/settings/global document
 * @param {object} dataToUpdate 
 * @param {function} callback 
 */
const updateHomeGlobalSettingsToDb = (database_fns, mainDb, dataToUpdate, callback, appUser) => {
  if (_allowUpdates_settings) { //asdfasfasfd 
    return updateSettingsToDB_direct(_settingsUpdateModes.global, database_fns, mainDb, dataToUpdate, 'home', true, false, appUser, callback)
  } else {
    callback({ success: false })
  }
}

/**
 * This will update the global, viewItems and views documents to the database
 * @param {object} allAppSettings 
 * @param {function} response 
 */
const updateSettingsDocsToDatabase = async (database_fns, allAppSettings, response) => {
  settingsDocsPromise(database_fns, allAppSettings).then(res => {
    response({ type: grts.updateSuccess })
  }).catch(error => {
    response({ type: grts.updateError, error })
  })
}


/**
 * Updates 3 parts of the settings document (views/viewKey, views/viewKey+_list, viewItems/viewKey)
 * @param {string} viewKey 
 * @param {object} view 
 * @param {object} viewList 
 * @param {object} viewItem 
 * @param {object} pathViews 
 * @param {function} callback 
 */
const createNewViewAndViewItemsSettingsDB = async (database_fns, settingsProps, pathViews, callback) => {

  const settings_name = _settingsFs.root

  const _baseRef = createRefPath([settings_name, pathViews.events, _settingsFs.collection])

  updateViSettingsPromises(database_fns, settingsProps, _baseRef).then(res => {
    console.log('res', res)
  }).catch(error => {
    console.error(error);
  })

}

/**
 * Updates a settings item via dot notation. ('views.' + _view + '.viewItems.' + viewItem.key)
  * @param {object} pathViews 
 * @param {object} viewItem 
 * @param {string} viewKey 
 * @param {function} callback 
 */
const updateNewViewToViewsSettingsDB = async (database_fns, viewKey, views, pathViews, callback, forBackup) => {

  const settings_name = forBackup ? _settingsFs.rootBackup : _settingsFs.root
  const _refPath = []
  _refPath.push(settings_name, pathViews.events)

  const viewItem = views[viewKey]
  const viewItem_list = views[viewKey + '_list']

  const dataUpdate = {
    ['views.' + viewKey]: viewItem,
    ['views.' + viewKey + '_list']: viewItem_list,
  }

  // database_fns.update_doc(_refPath, dataUpdate, callback)
  database_fns.update_docc({
    refPath: _refPath,
    data: dataUpdate,
    dispatch: callback
  })
}

/**
 * Updates a setting's item via dot notation. ('views.' + _view + '.viewItems.' + viewItem.key)
* @param {object} pathViews 
 * @param {object} viewItem 
 * @param {string} viewKey 
 * @param {function} callback 
 */
const updateViewViewItemSettingsDB = async (database_fns, pathViews, viewItem, viewKey, callback) => {

  const settings_name = _settingsFs.collection

  let _refPath = []

  _refPath = createRefPath([settings_name, pathViews.events, _settingsFs.collection, 'views'])
  const _vv = !viewKey ? viewItem.key + '_list' : viewItem.key
  const dataUpdateN = { [_vv]: viewItem }
  // database_fns.update_doc(_refPath, dataUpdateN, callback)

  console.log('ref', _refPath, dataUpdateN)

  // database_fns.update_docc({
  //   refPath: _refPath,
  //   data: dataUpdateN,
  //   callback
  // })
}

const updateGlobalAndViewsDBSettings = async (fullDbSettings, paps_state, sandboxOn, appUser, callback) => {

  const dataUpdate = _.cloneDeep(fullDbSettings)

  let { settingsDocName } = paps_state ?? {}

  // ************ 
  let _docRootPath;

  _docRootPath = createRefPath([_settingsFs.root, settingsDocName])

  if (fullDbSettings.global) { dataFix.cleanUpData(fullDbSettings.global) }
  if (fullDbSettings.views) { dataFix.cleanUpData(fullDbSettings.views) }

  // if (docRoot.FE) { console.log(docRoot.FE.segments) }

  console.log('_docRootPath', _docRootPath)
  console.log('dataUpdate', dataUpdate)


  // database_fns.update_doc(_docRootPath, dataUpdate, callback)

}

const updateSettings_viewItemsOnly = async (database_fns, pathViews, settings, fieldName) => {

  const settings_name = _settingsFs.root

  const { viewItems, views } = settings

  const promises = []

  const baseRef = createRefPath([settings_name, pathViews.events])

  // settings/key/settings/viewItems
  if (viewItems) {
    const rp_vi = createRefPath([_settingsFs.collection, 'viewItems'], baseRef)
    console.log('viewItems', rp_vi, viewItems)
    // promises.push(database_fns.doc_set(rp_vi, viewItems))
  }

  if (views) {
    const rp_v = createRefPath([_settingsFs.collection, 'views'], baseRef)
    console.log('views', rp_v, views)
    // promises.push(database_fns.doc_set(rp_v, views))
  }

  return Promise.all(promises)

}

const updateSettings_viewViewItems = async (
  database_fns,
  mainDb,
  pathViews,      // object with .events = settingsKey
  docFieldKey,    // e.g. 'events'
  viewItems,
  appUser
) => {

  const batch = writeBatch(mainDb);

  const _timestamp = getNow()

  const status = {
    uid: appUser?.uid,
    displayName: appUser?.displayName,
    appVersion: _appVersion,
    lastUpdate: _timestamp,
    _timestamp: _timestamp
  }

  // update main settings
  const merge = true
  const refPath_base = createRefPath(['settings', pathViews.events]);
  database_fns.set_doc(refPath_base, status, merge, false, batch)

  // ✅ Correct: /settings/{settingsKey}/settings/views
  const refPath = createRefPath(['settings', pathViews.events, 'settings', 'views']);

  // ✅ Update the nested field, e.g. events.viewItems
  const dataToUpdate = {
    [`${docFieldKey}.viewItems`]: viewItems,
  };

  // refPath, data, allowSet, batch
  database_fns.doc_update(refPath, dataToUpdate, null, batch);

  // update the settings timestamp  
  database_fns.update_timestamp(_cacheGroupTypes.settings, pathViews.events, _timestamp, batch)

  return batch.commit();
};

/** 
 * Updates the settings (fuil). This is using `doc_set`. This will replace the existing settings for `view` and `viewItems`
 * @param {object} pathViews 
 * @param {object} viewItems 
 * @param {object} views 
 * @param {function} callback 
 * @returns 
 */
const createNewViewsAndViewItemsSettings = async (database_fns, pathViews, projectSettings, globalOnly, allback) => {

  const { viewItems, views, global } = projectSettings ?? {}

  const settings_name = _settingsFs.root

  let _global = dataFix.removeNulls(global)
  let _viewItems = dataFix.removeNulls(viewItems)
  let _views = dataFix.removeNulls(views)

  _viewItems = dataFix.removeUnderscoreKeys(_viewItems)
  _views = dataFix.removeUnderscoreKeys(_views)

  _viewItems = dataFix.removeKeys(_viewItems, [..._deleteViProps, ..._deleteItemProps])
  _views = dataFix.removeKeys(_views, [..._deleteViProps, ..._deleteItemProps])

  const promises = []

  const baseRef = createRefPath([settings_name, pathViews.events])

  if (globalOnly) {
    const rp_gl = createRefPath([_settingsFs.collection, 'global'], baseRef)
    promises.push(database_fns.doc_set(rp_gl, _global))
  } else {
    // settings/key/settings/viewItems
    const rp_vi = createRefPath([_settingsFs.collection, 'viewItems'], baseRef)
    promises.push(database_fns.doc_set(rp_vi, _viewItems))

    // settings/key/settings/views
    const rp_v = createRefPath([_settingsFs.collection, 'views'], baseRef)
    promises.push(database_fns.doc_set(rp_v, _views))
  }

  return Promise.all(promises)
}

/**
 * 
 * @param {object} settingsProps 
 * @param {string} baseRef 
 * @returns 
 */
const updateViSettingsPromises = async (database_fns, settingsProps, baseRef) => {

  const { viewKey, view, viewList, viewItem } = settingsProps

  dataFix.cleanUpData(viewItem)
  dataFix.cleanUpData(view)
  dataFix.cleanUpData(viewList)

  const promises = []

  const _refPath_viewItems = createRefPath(['viewItems'], baseRef)
  const _refPath_views = createRefPath(['views'], baseRef)

  const dataUpdate_viewItems = {
    [viewKey]: viewItem,
  }

  const dataUpdate_views = {
    [viewKey]: view,
    [viewKey + '_list']: viewList,
  }

  promises.push(database_fns.update_doc(_refPath_viewItems, dataUpdate_viewItems, null, true))
  promises.push(database_fns.update_doc(_refPath_views, dataUpdate_views, null, true))

  return Promise.all(promises)
}

/**
 * 
 * @param {object} viewItems 
 */
const ammendDeleteFields = (viewItems, replaceFull) => {
  if (viewItems) {
    _.forEach(viewItems, (viewItem, key) => {
      const { props, propSections } = viewItem ?? {}
      if (viewItem.key && _.isObject(viewItem.key) && viewItem.key._methodName) {
        viewItem.key = key
      }
      if (viewItem._deleteMe || viewItem.remove) {
        viewItems[key] = replaceFull ? '_deleteMe' : deleteField()
      } else {
        _.forEach(viewItem, (viewItemProp, propKey) => {
          if (_.isObject(viewItemProp) && (viewItemProp._deleteMe || viewItemProp.remove)) {
            viewItem[propKey] = replaceFull ? '_deleteMe' : deleteField()
          }
        })
      }
      if (propSections) {
        _.forEach(propSections, (propSection, psKey) => {
          if (_.isObject(propSection) && (propSection._deleteMe || propSection.remove)) {
            viewItem.propSections[psKey] = replaceFull ? '_deleteMe' : deleteField()
          }
        })
      }
      if (props) {
        _.forEach(props, (prop, pKey) => {
          if (_.isObject(prop) && (prop._deleteMe || prop.remove)) {
            viewItem.props[pKey] = replaceFull ? '_deleteMe' : deleteField()
          }
        })
      }
    })
  }
}

/**
 * Updates the event status in the database 
 * @param {object} dataUpdate 
 * @param {object} pathViews 
 */
const updateEventStatus = (database_fns, dataUpdate, pathViews) => {
  const { global } = dataUpdate ?? {}
  const { appStatus } = global ?? {}
  if (appStatus) {
    const _refPath = createRefPath_event(pathViews)
    const data = global.appStatus
    database_fns.update_doc(_refPath, data)
  }
}

const settingsUpdate_fromSidebar = async (database_fns, mainDb, settingsDocName, trueViewKey, data, appUser, callback) => {

  const updateSb = () => {
    const merge = true
    const { displayName, uid } = appUser ?? {}

    const status = {
      uid,
      displayName,
      appVersion: _appVersion,
      lastUpdate: getNow()
    }

    const baseRef = createRefPath([_settingsFs.root, settingsDocName])

    const batch = writeBatch(mainDb);

    if (_allowUpdates_fromSidebar) {
      promises.push(database_fns.set_doc(baseRef, status, merge, false, batch))
    } else {
      console.log('settingsUpdate_fromSidebar', baseRef, status)
    }

    const rp_v = createRefPath([_settingsFs.collection, 'views'], baseRef)
    const _data = { [trueViewKey]: data }

    if (_allowUpdates_fromSidebar) {
      promises.push(database_fns.set_doc(rp_v, _data, merge, false, batch))
    } else {
      console.log('settingsUpdate_fromSidebar', rp_v, _data)
    }
    return batch.commit()
  }

  updateSb().then(res => {
    callback && callback()
  })

}

const settingsUpdate_globalFromSidebar = async (database_fns, mainDb, pathViews, data, appUser, callback) => {
  const updateSb = async () => {
    const merge = true
    return updateSettingsToDB_direct(_settingsUpdateModes.global, database_fns, mainDb, data, pathViews.events, merge, false, appUser, callback)
  }
  updateSb().then(res => {
    callback()
  })

}

/**
 * This will update the global, viewItems and views documents to the database
 * @param {object} allAppSettings 
 * @param {function} response 
 */
const settingsDocsPromise = async (database_fns, allAppSettings) => {
  const promises = []
  // loop the allAppSettings
  Object.keys(allAppSettings).forEach(settingsKey => {
    const baseRef = createRefPath([_settingsFs.root, settingsKey])
    const appSettings = allAppSettings[settingsKey]
    const { global, viewItems, views } = appSettings
    if (global && views && viewItems) {
      // loop the docs within appSettings
      Object.keys(appSettings).forEach(docKey => {
        const _settingsRef = createRefPath([_settingsFs.collection, docKey], baseRef)
        const appSetting = dataFix.removeAllEmpties(appSettings[docKey])
        promises.push(database_fns.doc_set(_settingsRef, appSetting))
      })
    }
  })
  return Promise.all(promises)
}

const m = (o, doc, path) => {
  o[doc.id] = {
    ...doc.data(),
    id: doc.id
  }
}


const updateTimestamp_settings = (database_fns, settingsDocName, timestamp) => {
  // tsType, tsKey, ts
  database_fns.update_timestamp(_cacheGroupTypes.settings, settingsDocName, timestamp)
} 